var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAnalytics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44932",
    "data-name": "Group 44932",
    transform: "translate(-1013 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Analytic",
    "data-name": "icon/Analytic",
    transform: "translate(6659.615 12878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14086",
    "data-name": "Rectangle 14086",
    width: 24,
    height: 24,
    transform: "translate(-5646.615 -12017)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_Analytic-2",
    "data-name": "icon/Analytic",
    d: "M184.122,292.338a.78.78,0,0,0-.765.784v4.323h4.057v-4.323a.78.78,0,0,0-.765-.784Zm5.958-3.111a.78.78,0,0,0-.765.784v7.434h4.057v-7.434a.78.78,0,0,0-.765-.784Zm5.17-2.351v10.569h4.057V286.876a.78.78,0,0,0-.765-.784h-2.55A.794.794,0,0,0,195.25,286.876ZM184.725,290.3l7.46-6.032.9,1.045a.722.722,0,0,0,1.252-.333l1.191-4.967a.748.748,0,0,0-.542-.908.718.718,0,0,0-.269-.018l-4.938.665a.771.771,0,0,0-.464,1.261l.9,1.045-6.677,6.911a.92.92,0,0,0-.07,1.188.892.892,0,0,0,1.253.146Zm16,8.906H181.433V284.642a.915.915,0,0,0-.9-.926.932.932,0,0,0-.9.926v15.509a.916.916,0,0,0,.9.926h20.192a.918.918,0,0,0,.9-.926A.938.938,0,0,0,200.725,299.2Z",
    transform: "translate(-5825.244 -12295.077)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAnalytics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_analytics.1f61af130edc4331a3a900fa63fd2709.svg";